import { APP_ENV } from "@/APP_ENV";
import GoogleMapWrapper from "./GoogleMapWrapper";
import MapPlaceholder from "./MapPlaceholder";

export function getMapProvider() {
  switch (APP_ENV.REACT_APP_MAP_PROVIDER) {
    case "google":
      return GoogleMapWrapper;
    case "amap":
      break;
    default:
      break;
  }
  return MapPlaceholder;
}
